import React from 'react'
import TagBarcode from './TagBarcode'
//import { useSelector } from 'react-redux'
import { todayDate, formatMoneyAuto } from 'helpers/helpers'
import { resolveBarcode, cleanBarcode, pxToMm } from 'helpers/barcode'

// .price_tag_body_30x20 eni
const LABEL_WIDTH = 140

// Shtrix-kod formati va chiziq qalinligi -- markazlashgan helpers/barcode.js orqali
// (barcha yorliqlarda bir xil). Kod tozalanadi (backend bo'sh joy qo'shib qaytaradi),
// haqiqiy EAN-13/EAN-8 -> o'z formati, aks holda CODE128; qalinlik 30mm yorliqqa moslanadi.
//
// 30 mm yorliqda format muhim: 13 xonali kod CODE128 da chiziq 0.21mm, EAN-13 da 0.26mm
// egallaydi. Skaner minimumi ~0.25mm -- shuning uchun EAN-13 bo'lsa o'z formatida chiziladi.
function barcodeOptions(barcode) {
	const opts = resolveBarcode(cleanBarcode(barcode), pxToMm(LABEL_WIDTH))
	if (!opts) return { format: 'CODE128', width: 0.9 }
	return { format: opts.format, lastChar: opts.lastChar, width: opts.width }
}

function PriceTag30x20({
	data,
	selectedPriceTag,
	selectPriceTag,
	printProducts,
	printRef,
	activateWholeSalePrice,
	cashbox,
	a4 = false,
	activeDate = true,
}) {

	return (
		<>
			<div className="d-flex flex-wrap">
				<div className={"price_tag_body_30x20 price-tag-border mb-3 me-3 " + (selectedPriceTag.priceTag30x20_1 && 'border-primary')}
					onClick={() => selectPriceTag('priceTag30x20_1')}>
					<div className="vertical-center">
						<div className="price_tag_30x20_1_name">
							{data.productName}
						</div>
					</div>
					<div className="d-flex justify-content-center price_tag_30x20_1_price">
						<div className={'d-flex ' + (formatMoneyAuto(data.salePrice).length > 7 ? "fz18" : "fz22")}>
							<div className="vertical-center me-1">
								<span className="fw-700 text-nowrap">
									{formatMoneyAuto(data.salePrice)}
								</span>
							</div>
						</div>
						<div className={'vertical-center ' + (formatMoneyAuto(data.salePrice).length > 7 ? "fz18" : "fz22")}>
							<b>{data?.currencyName || cashbox.defaultCurrency}</b>
						</div>
					</div>
					<div className="d-flex justify-content-center barcode">
						<div>
							<TagBarcode value={data.barcode} height={20} background="transparent" textMargin={0}
								fontOptions="" fontSize={10} {...barcodeOptions(data.barcode)} />
						</div>
					</div>
					{data.barcodeScales && (
						<div className="fz8 mx-2 position-absolute bottom-0 start-10px ">PLU: {data.barcodeScales}</div>
					)}
					<div className="fz6 date">{todayDate()}</div>
				</div>

				<div className={"price_tag_body_30x20 price-tag-border mb-3 me-3 " + (selectedPriceTag.priceTag30x20_2 && 'border-primary')}
					onClick={() => selectPriceTag('priceTag30x20_2')}>
					<div className="vertical-center">
						<div className="price_tag_30x20_2_name">
							{data.productName}
						</div>
					</div>
					<div className="d-flex justify-content-center price_tag_30x20_2_price">
						<div className={'d-flex ' + (formatMoneyAuto(data.salePrice).length > 7 ? "fz18" : "fz22")}>
							<div className="vertical-center me-1">
								<span className="fw-700 text-nowrap">{formatMoneyAuto(data.salePrice)}</span>
							</div>
						</div>
						<div className={'vertical-center ' + (formatMoneyAuto(data.salePrice).length > 7 ? "fz18" : "fz22")}>
							<b>{data?.currencyName || cashbox.defaultCurrency}</b>
						</div>
					</div>
					{data.barcodeScales && (
						<div className="fz8 mx-2 position-absolute bottom-0 start-10px ">PLU: {data.barcodeScales}</div>
					)}

					<div className="fz6 date">{todayDate()}</div>
				</div>

				<div className={"price_tag_body_30x20 price-tag-border mb-3 me-3 " + (selectedPriceTag.priceTag30x20_3 && 'border-primary')}
					onClick={() => selectPriceTag('priceTag30x20_3')}>
					<div className="vertical-center">
						<div className="price_tag_30x20_3_name">
							{data.productName}
						</div>
					</div>
					<div className="d-flex justify-content-center price_tag_30x20_3_price">
						<div className={'d-flex ' + (formatMoneyAuto(data.salePrice).length > 7 ? "fz18" : "fz22")}>
							<div className="vertical-center me-1">
								<span className="fw-700 text-nowrap">{formatMoneyAuto(data.salePrice)}</span>
							</div>
						</div>
						<div className={'vertical-center ' + (formatMoneyAuto(data.salePrice).length > 7 ? "fz18" : "fz22")}>
							<b>{data?.currencyName || cashbox.defaultCurrency}</b>
						</div>
						{data.barcodeScales && (
							<div className="fz8 mx-2 position-absolute top-5px start-10px ">PLU: {data.barcodeScales}</div>
						)}
					</div>
					<div className="d-flex justify-content-center barcode">
						<TagBarcode value={data.barcode} height={20} background="transparent" displayValue={false} {...barcodeOptions(data.barcode)} />
					</div>
				</div>

				<div className={"price_tag_body_30x20 price-tag-border mb-3 me-3 " + (selectedPriceTag.priceTag30x20_4 && 'border-primary')}
					onClick={() => selectPriceTag('priceTag30x20_4')}>
					<div className="vertical-center">
						<div className="price_tag_30x20_3_name">
							{data.productName}
						</div>
					</div>
					<div className="d-flex justify-content-center barcode">
						<div>
							<TagBarcode value={data.barcode} height={40} background="transparent" textMargin={2}
								fontOptions="" fontSize={10} margin={0} marginBottom={6}
								{...barcodeOptions(data.barcode)} />
						</div>
					</div>
					{data.barcodeScales && (
						<div className="fz8 mx-2 position-absolute bottom-0 start-10px ">PLU: {data.barcodeScales}</div>
					)}
					<div className="fz6 date">{todayDate()}</div>
				</div>
			</div>

			<div className="d-none">
				{selectedPriceTag.priceTag30x20_1 &&
					<div ref={printRef} className={"price-tag-wrap " + (a4 ? 'a4 ' : ' ') + (activeDate ? ' ' : 'hide-date ')}>
						{printProducts.map((product, index) => (
							<div className="price_tag_body_30x20 page-breaker" key={index}>
								<div className="vertical-center">
									<div className="price_tag_30x20_1_name">
										{product.productName}
									</div>
								</div>
								<div className="d-flex justify-content-center price_tag_30x20_1_price">
									<div className={'d-flex ' + (formatMoneyAuto(product.salePrice).length > 7 ? "fz18" : "fz22")}>
										<div className="vertical-center me-1">
											<span className="fw-700 text-nowrap">{formatMoneyAuto(product.salePrice)}</span>
										</div>
									</div>
									<div className={'vertical-center ' + (formatMoneyAuto(product.salePrice).length > 7 ? "fz18" : "fz22")}>
										<b>{product?.currencyName || cashbox.defaultCurrency}</b>
									</div>
								</div>
								<div className="d-flex justify-content-center barcode">
									<div>
										<TagBarcode value={product.barcode} height={20} background="transparent" textMargin={0}
											fontOptions="" fontSize={10} {...barcodeOptions(product.barcode)} />
									</div>
								</div>
								{product.barcodeScales &&
									<div className="fz8 mx-2 position-absolute bottom-0 start-10px ">PLU: {product.barcodeScales}</div>
								}
								<div className="fz6 date">{todayDate()}</div>
							</div>
						))
						}
					</div>
				}

				{selectedPriceTag.priceTag30x20_2 &&
					<div ref={printRef} className={"price-tag-wrap " + (a4 ? 'a4 ' : ' ') + (activeDate ? ' ' : 'hide-date ')}>
						{printProducts.map((product, index) => (
							<div className="price_tag_body_30x20 page-breaker" key={index}>
								<div className="vertical-center">
									<div className="price_tag_30x20_2_name">
										{product.productName}
									</div>
								</div>
								<div className="d-flex justify-content-center price_tag_30x20_2_price">
									<div className={'d-flex ' + (formatMoneyAuto(product.salePrice).length > 7 ? "fz18" : "fz22")}>
										<div className="vertical-center me-1">
											<span className="fw-700 text-nowrap">{formatMoneyAuto(product.salePrice)}</span>
										</div>
									</div>
									<div className={'vertical-center ' + (formatMoneyAuto(product.salePrice).length > 7 ? "fz18" : "fz22")}>
										<b>{product?.currencyName || cashbox.defaultCurrency}</b>
									</div>
								</div>
								{product.barcodeScales &&
									<div className="fz8 mx-2 position-absolute bottom-0 start-10px ">PLU: {product.barcodeScales}</div>
								}
								<div className="fz6 date">{todayDate()}</div>
							</div>
						))
						}
					</div>
				}

				{selectedPriceTag.priceTag30x20_3 &&
					<div ref={printRef} className={"price-tag-wrap " + (a4 ? 'a4 ' : ' ') + (activeDate ? ' ' : 'hide-date ')}>
						{printProducts.map((product, index) => (
							<div className="price_tag_body_30x20 page-breaker" key={index}>
								<div className="vertical-center">
									<div className="price_tag_30x20_3_name">
										{product.productName}
									</div>
								</div>
								<div className="d-flex justify-content-center price_tag_30x20_3_price">
									<div className={'d-flex ' + (formatMoneyAuto(product.salePrice).length > 7 ? "fz18" : "fz22")}>
										<div className="vertical-center me-1">
											<span className="fw-700 text-nowrap">{formatMoneyAuto(product.salePrice)}</span>
										</div>
									</div>
									<div className={'vertical-center ' + (formatMoneyAuto(product.salePrice).length > 7 ? "fz18" : "fz22")}>
										<b>{product?.currencyName || cashbox.defaultCurrency}</b>
									</div>
									{product.barcodeScales &&
										<div className="fz8 mx-2 position-absolute top-5px start-10px ">PLU: {product.barcodeScales}</div>
									}
								</div>
								<div className="d-flex justify-content-center barcode">
									<TagBarcode value={product.barcode} height={20} background="transparent" displayValue={false} {...barcodeOptions(product.barcode)} />
								</div>
							</div>
						))
						}
					</div>
				}

				{selectedPriceTag.priceTag30x20_4 &&
					<div ref={printRef} className={"price-tag-wrap " + (a4 ? 'a4 ' : ' ') + + (activeDate ? ' ' : 'hide-date ')}>
						{printProducts.map((product, index) => (
							<div className="price_tag_body_30x20 page-breaker" key={index}>
								<div className="vertical-center">
									<div className="price_tag_30x20_3_name">
										{product.productName}
									</div>
								</div>
								<div className="d-flex justify-content-center barcode">
									<div>
										<TagBarcode value={product.barcode} height={40} background="transparent" textMargin={2}
											fontOptions="" fontSize={10} margin={0} marginBottom={6}
											{...barcodeOptions(product.barcode)} />
									</div>
								</div>
								{product.barcodeScales &&
									<div className="fz8 mx-2 position-absolute bottom-0 start-10px ">PLU: {product.barcodeScales}</div>
								}
								<div className="fz6 date">{todayDate()}</div>
							</div>
						))
						}
					</div>
				}

			</div>
		</>
	)
}

export default PriceTag30x20